var render, staticRenderFns
import script from "./ProcessViewer.vue?vue&type=script&lang=js&"
export * from "./ProcessViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProcessViewer.vue?vue&type=style&index=0&id=6b48c1d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48c1d2",
  null
  
)

export default component.exports